import { BundleTypeConfigurationsService } from "@/api/services/bundle-type-configurations.service";
import { DataService } from "@/api/services/data.service";
import { DropdownTypes } from "@/constants/constants";

const list = (_: any, params?: { page?: number; limit?: number; search?: string }) =>
	new Promise((resolve, reject) => {
		BundleTypeConfigurationsService.list(params)
			.then((r) => resolve(r.data))
			.catch(reject);
	});

const create = (_: any, { data }: { data: any }) =>
	new Promise((resolve, reject) => {
		BundleTypeConfigurationsService.create(data)
			.then((r) => resolve(r.data))
			.catch(reject);
	});

const update = (_: any, { id, data }: { id: number; data: any }) =>
	new Promise((resolve, reject) => {
		BundleTypeConfigurationsService.update(id, data)
			.then((r) => resolve(r.data))
			.catch(reject);
	});

const remove = (_: any, { id }: { id: number }) =>
	new Promise((resolve, reject) => {
		BundleTypeConfigurationsService.delete(id)
			.then((r) => resolve(r.data))
			.catch(reject);
	});

const getCustomerTypes = () => DataService.findDropdownData({ name: DropdownTypes.CUSTOMER_TYPES });

const getOptions = (_: any, params: { field: string; limit?: number; isExtra?: boolean; isExtraMobile?: boolean }) =>
	new Promise((resolve, reject) => {
		BundleTypeConfigurationsService.getOptions(params)
			.then((r) => resolve(r.data))
			.catch(reject);
	});

export default {
	list,
	create,
	update,
	remove,
	getOptions,
	getCustomerTypes
};
